module.exports = __webpack_public_path__ + "static/media/eyowo.5b09662f.svg";